import { ComponentProps } from "react";
import { FieldValues } from "react-hook-form";

import Input from "@components/fields/Input";

type Props<FormData extends FieldValues> = Omit<
  ComponentProps<typeof Input<FormData>>,
  "fill" | "labelPlacement" | "simpleInput"
>;

const CareProfileInput = <FormData extends FieldValues>({ ...inputProps }: Props<FormData>) => (
  <Input {...inputProps} fill={undefined} labelPlacement={undefined} simpleInput />
);

export default CareProfileInput;
